import { ValueOf } from "../../../types";
import { GRADIENT_PROGRESS_BAR_DIRECTION_NAMES } from "../constants";
import _ from "lodash";

interface IAnimationPreset {
    activeCount: number;
    direction: ValueOf<typeof GRADIENT_PROGRESS_BAR_DIRECTION_NAMES>;
}

function getAnimationPresets(count: number): IAnimationPreset[] {
    const normalDirectionPresets: IAnimationPreset[] = _.times(count, (index) => ({
        activeCount: count - index,
        direction: GRADIENT_PROGRESS_BAR_DIRECTION_NAMES.NORMAL,
    }));

    const reverseDirectionPresets: IAnimationPreset[] = _.times(count, (index) => ({
        activeCount: index + 1,
        direction: GRADIENT_PROGRESS_BAR_DIRECTION_NAMES.REVERSE,
    }));

    return [...normalDirectionPresets, {
        activeCount: 0,
        direction: GRADIENT_PROGRESS_BAR_DIRECTION_NAMES.NORMAL
    }, ...reverseDirectionPresets];
}

export default getAnimationPresets;
